import { Module, VuexModule, getModule, Mutation, Action, MutationAction } from 'vuex-module-decorators';
import store from '~common-store';
import { LayoutState } from '~/interfaces/layout.interface';

@Module({ dynamic: true, store, name: 'supportLayout', namespaced: true })
class Layout extends VuexModule implements LayoutState {
    isRoomModeActive = true;
    treeFilter = '';
    isDarkModeActive = true;
    isSideMenuOpen = false;

    @Mutation
    SET_DARK_MODE_ACTIVE(isDarkModeActive: boolean) {
        this.isDarkModeActive = isDarkModeActive;
    }

    @Action({ commit: 'SET_DARK_MODE_ACTIVE' })
    toggleDarkModeActive() {
        window.localStorage.setItem('darkMode', String(!this.isDarkModeActive));
        return !this.isDarkModeActive;
    }
    @Action({ commit: 'SET_DARK_MODE_ACTIVE' })
    setDarkMode(darkmode: boolean) {
        return darkmode;
    }

    @Mutation
    SET_SIDE_MENU_OPEN(isSideMenuOpen: boolean) {
        this.isSideMenuOpen = isSideMenuOpen;
    }

    @Action({ commit: 'SET_SIDE_MENU_OPEN' })
    toggleSideMenuOpen() {
        return !this.isSideMenuOpen;
    }

    @Mutation
    SET_IS_ROOM_MODE_ACTIVE(isRoomModeActive: boolean) {
        this.isRoomModeActive = isRoomModeActive;
    }

    @Action({ commit: 'SET_IS_ROOM_MODE_ACTIVE' })
    setRoomModeActive(value: boolean) {
        window.localStorage.setItem('isRoomModeActive', String(value));
        return value;
    }

    @MutationAction
    async setTreeFilter(treeFilter: string) {
        return { treeFilter };
    }
}

export const LayoutModule = getModule(Layout);
